import { connect } from 'react-redux'
import { compose } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTRecommendedProductService from './BOTRecommendedProductService'

export default compose(
  withType({ type: 'BOTRecommendedProductService' }),
  connect(({ addToQuote }) => addToQuote)
)(BOTRecommendedProductService)
